export const setUserDataAction = userData => ({
    type: 'SET_USER',
    userData,
  })
